import axios from 'axios'

export default class UserService {
  static async getUserPassword (userId) {
    return axios
      .get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/user/' + userId + '/password')
      .then(response => response)
  }

  static async changeUserPassword (request) {
    await axios
      .put(process.env.VUE_APP_INTERNAL_API_BASEURL + '/user/' + request.userId + '/password',
        {
          oldPassword: null, // Not required when we call internal-api
          newPassword: request.password
        })
  }

  static async deleteUser (request) {
    await axios
      .delete(process.env.VUE_APP_INTERNAL_API_BASEURL + '/user/' + request.userId,{
        params:{
          force: request.force
          }
      })
  }

  static async searchUser (user) {
     return axios
       .get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/user/' , {
         params:{
           user: user,
           pageSize: process.env.VUE_APP_MAX_RESULT_PER_PAGE
           }
       })
         .then(response => response.data)
  }
}
